import React from 'react';
import { Button, Icon } from '..';
import { constructClassName } from '../../utils/constructClassName';
import colors from '../../styles/colors/index.module.scss';
import styles from './styles.module.scss';

interface Props {
  title?: string;
  message: string;
  type?: 'info' | 'warning' | 'error' | 'success';
  onHidden?: () => void;
  prompt?: string;
  onClick?: () => void;
  className?: string;
}

export const Notice: React.FC<Props> = ({
  title,
  message,
  type = 'info',
  onHidden,
  prompt,
  onClick,
  className,
}) => (
  <div className={constructClassName([
    styles.container,
    styles[type],
    className,
  ])}
  >
    <div className={styles.contentContainer}>
      <div className={styles.leftContentContainer}>
        {type === 'success' && (
          <Icon
            icon="circleCheckClassicLight"
            fill={colors.secondary}
          />
        )}
        {type === 'error' && (
          <Icon
            icon="circleXClassicLight"
            fill={colors.white}
          />
        )}
        {type === 'warning' && (
          <Icon
            icon="circleExclamationClassicLight"
            fill={colors.yellow}
          />
        )}
        <div>
          {title && (<span className={styles.title}>{title}</span>)}
          <span>
            {message}
          </span>
        </div>
        {prompt && (
          <Button
            type="link"
            className={styles[type]}
            onClick={onClick}
          >
            <p className={styles.promptText}>{prompt}</p>
          </Button>
        )}
      </div>
      {
        onHidden ? (
          <Button
            type="link"
            className={styles.dismissToastNotice}
            onClick={onHidden}
          >
            {type === 'success' && (
              <Icon
                icon="xClassicRegular"
                fill={colors.secondary}
                size={15}
              />
            )}
            {type === 'error' && (
              <Icon
                icon="xClassicRegular"
                fill={colors.white}
                size={15}
              />
            )}
            {type === 'warning' && (
              <Icon
                icon="xClassicRegular"
                fill={colors.yellow}
                size={15}
              />
            )}
          </Button>
        ) : null
      }
    </div>
  </div>
);
